import { Divider, List, ListItem, Tooltip } from "@mui/material";
import { useModal } from "../../hooks/modalStore";
import Styles from "./SolvinngHistoryGrid.module.css";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import moment from "moment";
import { testType } from "../../utils/testHelper";

export default function SolvingHistoryGrid({
  title,
  biletId,
  themeId,
  type,
  logData,
}) {
  const modalStore = useModal();
  const handleClose = () => modalStore.handleClose();

  return (
    <section className={Styles.history_grid_section}>
      <div className={Styles.history_grid_wrapper}>
        <div className={Styles.history_grid_title}>
          <h6>{title}</h6>
          <CloseRoundedIcon onClick={handleClose} />
        </div>
        <Divider style={{ borderBottomWidth: "small" }} />
        <div className={Styles.history_grid_content}>
          {((!logData || !logData.length) && (
            <p
              className="no_data"
              style={{ margin: "auto", height: "min-content" }}>
              Нет записей о решении
            </p>
          )) || (
            <List className={Styles.history_list}>
              <div className={Styles.list_legenda}>
                <span>Начало теста</span>
                <span style={{ width: "min-content", marginLeft: "20px" }}>
                  Название
                </span>
                <span>Результат</span>
                <span>Затраченное время</span>
              </div>
              {logData.map((log) => {
                const {
                  bilet_name,
                  theme_name,
                  start_time,
                  finish_time,
                  canceled_count,
                  wrong_count,
                  correct_count,
                  test_type,
                } = log;

                const all = wrong_count + correct_count + canceled_count;

                const testDuration = moment.duration(
                  moment.unix(finish_time).diff(moment.unix(start_time))
                );
                return (
                  <>
                    <ListItem className={Styles.history_item}>
                      <p>
                        {moment.unix(start_time).format("MM.DD.YYYY HH:mm:ss ")}
                      </p>
                      <p
                        style={{
                          width: "100%",
                          textAlign: "start",
                          marginLeft: "20px",
                        }}>
                        {bilet_name || theme_name || "Марафон ПДД ПМР "}
                      </p>
                      <Tooltip
                        title="Неправильных / Пропущено / Верных / Всего"
                        placement="top">
                        <p className={Styles.history_results}>
                          <p className={Styles.history_wrong}>
                            {wrong_count}&nbsp;/&nbsp;{" "}
                          </p>
                          <p className={Styles.history_canceled}>
                            {test_type === testType.marathon.type
                              ? "-"
                              : canceled_count}
                            &nbsp;/&nbsp;
                          </p>
                          <p className={Styles.history_correct}>
                            {correct_count}&nbsp;/&nbsp;
                          </p>
                          <p className={Styles.history_all}>
                            {test_type === testType.marathon.type ? "-" : all}
                          </p>
                        </p>
                      </Tooltip>
                      <p>
                        {testDuration.hours().toString().length == 1
                          ? "0" + testDuration.hours()
                          : testDuration.hours()}
                        :
                        {testDuration.minutes().toString().length == 1
                          ? "0" + testDuration.minutes()
                          : testDuration.minutes()}
                        :
                        {testDuration.seconds().toString().length == 1
                          ? "0" + testDuration.seconds()
                          : testDuration.seconds()}
                      </p>
                    </ListItem>
                    <Divider />
                  </>
                );
              })}
            </List>
          )}
        </div>
      </div>
    </section>
  );
}
